var map = {
	"./en/common.json": 2551,
	"./en/errors.json": 2552,
	"./en/labels.json": 2553,
	"./es/common.json": 2554,
	"./es/errors.json": 2555,
	"./es/labels.json": 2556
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2550;